export default __webpack_public_path__ + "static/media/Group8558.6e5e833d.svg";